import { defineMessages } from 'react-intl';
import messages
    from "gw-capability-gateway-quoteandbind-common-react/pages/GatewayConfirmation/GatewayConfirmationPage.messages";

export default defineMessages({
    driverExclusionAgreementPopupHeader: {
        id: 'ml.quoteandbind.driverExclusionAgreementPopup.Driver Exclusion Agreement',
        defaultMessage: 'Driver Exclusion Agreement',
    },
    driverExclusionAgreementPopupContent: {
        id: 'ml.quoteandbind.driverExclusionAgreementPopup.DriverExclusionAgreementContent',
        defaultMessage: 'Oregon excluded drivers must meet one of the following requirements:  \n' +
            '<ol>' +
            '\t<li>Rating the driver(s) would cause a financial hardship to the named insured by increasing the premium for liability coverage $1,000 or more annually or $500 or more semi-annual; or\n' +
            'Liability Premium as Rated   \t {ratedPremium}\n' +
            'Liability Premium as Excluded\t {excludedPremium}\n' +
            '</li>' +
            '\t<li>The driver(s) Oregon driver\'s license is suspended when a record of conviction of an offense for a conviction of aggravated vehicular homicide or aggravated driving while suspended/revoked or any degree of murder, manslaughter or criminally negligent homicide resulting from the operation of a motor vehicle or assault in the first or a conviction of any felony with a material element involving the operation of a motor vehicle (ORS 809.409(5)); or\n' +
            '</li>' +
            '\t<li>The driver(s) Oregon driver\'s license is suspended pursuant to when a person who is incompetent to drive a motor vehicle because of a mental or physical condition or impairment that affects the person’s ability to safely operate a motor vehicle upon the highways (ORS 809.419(3); or\n' +
            '</li>' +
            '\t<li>The driving record, within the last three years immediately preceding the application or renewal of the policy, of the person being excluded does not meet underwriting guidelines (excluding not-at-faults).\n' +
            '</li></ol>' +
            'By selecting to exclude the driver(s) on this policy, I acknowledge this exclusion is due to one or more of the legally permitted reasons above.\n\n'
    },
    radioButtonExcluded: {
        id: 'ml.quoteandbind.driverExclusionAgreementPopup.I agree, submit as excluded',
        defaultMessage: '"Applicant agrees, submit as excluded"'
    },
    radioButtonNondriver: {
        id: 'ml.quoteandbind.driverExclusionAgreementPopup.I do not agree, submit as non driver',
        defaultMessage: '"Applicant does not agree, submit as non driver"'
    },
    radioButtonExcludedQnB: {
        id: 'ml.quoteandbind.driverExclusionAgreementPopup.qnb.I agree, submit as excluded',
        defaultMessage: 'I agree, submit as excluded driver'
    },
    radioButtonNondriverQnB: {
        id: "ml.quoteandbind.driverExclusionAgreementPopup.qnb.I don't agree, submit as non driver",
        defaultMessage: "I don't agree, submit as non driver"
    }
});